var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "value-swiper" }, [
    _c("div", { staticClass: "value-swiper__navigation" }, [
      _c(
        "div",
        {
          staticClass:
            "value-swiper__navigation-arrow value-swiper__navigation-arrow--left"
        },
        [_c("icon", { attrs: { name: "long-arrow-left", size: "32px" } })],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "value-swiper__navigation-arrow value-swiper__navigation-arrow--right"
        },
        [_c("icon", { attrs: { name: "long-arrow-right", size: "32px" } })],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "value-swiper__wrapper" },
      [
        _c(
          "swiper",
          { ref: "valueProps", attrs: { options: _vm.swiperOptions } },
          _vm._l(_vm.valueProps, function(prop) {
            return _c(
              "swiper-slide",
              { key: prop.id, staticClass: "value-swiper__slide" },
              [
                prop.valueImage
                  ? _c("img", {
                      staticClass: "value-swiper__slide-image",
                      attrs: { src: prop.valueImage, alt: prop.valueTitle }
                    })
                  : _vm._e(),
                prop.valueTitle
                  ? _c("h6", {
                      staticClass: "value-swiper__slide-title",
                      domProps: { innerHTML: _vm._s(prop.valueTitle) }
                    })
                  : _vm._e(),
                prop.valueDescription
                  ? _c("div", {
                      staticClass: "value-swiper__slide-description",
                      domProps: { innerHTML: _vm._s(prop.valueDescription) }
                    })
                  : _vm._e(),
                prop.valueCtaText && prop.valueCtaUrl
                  ? _c(
                      "a",
                      {
                        staticClass: "value-swiper__slide-link",
                        attrs: {
                          href: prop.valueCtaUrl,
                          title: prop.valueCtaText
                        }
                      },
                      [_vm._v(_vm._s(prop.valueCtaText))]
                    )
                  : _vm._e()
              ]
            )
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }